import { useFullStory } from "#webapp/src/util/fullstory";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import AIChatPlusCalendar from "../components/chat-plus-calendar/AIChatPlusCalendar";
import { AIModalPaywall } from "../components/chat-plus-calendar/AIModalPaywall";
import { useFeatureFlag } from "../launch-darkly";
import { page, PageEvents } from "../util/analytics.util";

const AIPage = ({ data }: { data?: { titleOverride: string } }) => {
  const { identify } = useFullStory();
  const [aiAccess, _, ldInitialized] = useFeatureFlag("ClockwiseAI");
  const titleOverride = data?.titleOverride;

  const ldLoading = !ldInitialized;

  useEffect(() => {
    page(PageEvents.AI_PAGE);
  }, []);

  useEffect(() => {
    identify();
  }, [identify]);

  if (ldLoading) {
    // prevent flicker
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{titleOverride || "AI · Clockwise"}</title>
      </Helmet>
      <div className="cw-w-full">
        {!aiAccess && <AIModalPaywall />}
        <AIChatPlusCalendar />
      </div>
    </>
  );
};

export default AIPage;
